import BaseEntityAutocompleteOrCreate, {
  AutocompleteType,
  BaseEntityAutocompleteOrCreateInheritableProps,
} from "@/common/components/Entity/components/BaseEntityAutocompleteOrCreate";
import { CustomerDto } from "@/core/api/generated/v1";

import CustomerAutocomplete, { CustomerAutocompleteProps } from "./CustomerAutocomplete";
import CustomerCreateUpdate, { CustomerCreateUpdateProps } from "./CustomerCreateUpdate";
import CustomerCreateUpdateModal from "./CustomerCreateUpdateModal";

type Props = BaseEntityAutocompleteOrCreateInheritableProps<
  CustomerDto,
  CustomerCreateUpdateProps["defaultValues"],
  CustomerAutocompleteProps,
  CustomerCreateUpdateProps
>;

export default function CustomerAutocompleteOrCreate({ ...otherProps }: Props) {
  return (
    <BaseEntityAutocompleteOrCreate<
      CustomerDto,
      CustomerCreateUpdateProps["defaultValues"],
      CustomerAutocompleteProps,
      CustomerCreateUpdateProps
    >
      autocompleteType={AutocompleteType.Single}
      getDefaultValues={(params) => params.createUpdateProps?.defaultValues}
      renderAutocomplete={(params) => (
        <CustomerAutocomplete
          {...params.autocompleteProps}
          withCreate
          createOptionTitle={(inputValue) => `Create new customer "${inputValue}"`}
          onCreate={(newOption) => {
            params.setDefaultValues({
              ...params.defaultValues,
              nameOrEmail: newOption?.inputValue || params.defaultValues?.nameOrEmail || undefined,
            });
            params.setIsCreate(true);
            params.onCreateStart && params.onCreateStart();
          }}
        />
      )}
      renderCreateUpdate={(params) => (
        <CustomerCreateUpdate
          {...params.createUpdateProps}
          defaultValues={params.defaultValues}
          onCreate={params.onCreate}
          onSave={(newValue) => {
            params.setIsCreate(false);
          }}
        />
      )}
      renderCreateUpdateModal={(params) => (
        <CustomerCreateUpdateModal
          open={params.isCreate}
          onClose={() => params.setIsCreate(false)}
          createUpdateProps={{
            ...params.createUpdateProps,
            defaultValues: params.defaultValues,
            onCreate: params.onCreate,
            onSave: (newValue) => {
              params.setIsCreate(false);
            },
          }}
        />
      )}
      {...otherProps}
    />
  );
}
